module.exports = ReactIs;